const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDEFB"
    },
    d: "M 5 39 L 5 15 L 43 15 L 43 39 C 43 41.210938 41.210938 43 39 43 L 9 43 C 6.789063 43 5 41.210938 5 39 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2196F3"
    },
    d: "M 43 11 L 43 17 L 5 17 L 5 11 C 5 8.789063 6.789063 7 9 7 L 39 7 C 41.210938 7 43 8.789063 43 11 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1565C0"
    },
    d: "M 36 11 C 36 12.65625 34.65625 14 33 14 C 31.34375 14 30 12.65625 30 11 C 30 9.34375 31.34375 8 33 8 C 34.65625 8 36 9.34375 36 11 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1565C0"
    },
    d: "M 18 11 C 18 12.65625 16.65625 14 15 14 C 13.34375 14 12 12.65625 12 11 C 12 9.34375 13.34375 8 15 8 C 16.65625 8 18 9.34375 18 11 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0BEC5"
    },
    d: "M 33 4 C 31.894531 4 31 4.894531 31 6 L 31 11 C 31 12.105469 31.894531 13 33 13 C 34.105469 13 35 12.105469 35 11 L 35 6 C 35 4.894531 34.105469 4 33 4 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0BEC5"
    },
    d: "M 15 4 C 13.894531 4 13 4.894531 13 6 L 13 11 C 13 12.105469 13.894531 13 15 13 C 16.105469 13 17 12.105469 17 11 L 17 6 C 17 4.894531 16.105469 4 15 4 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1565C0"
    },
    d: "M 21.703125 31.777344 L 23.308594 23 L 26.65625 23 L 23.683594 37 L 20.183594 37 L 18.308594 29.019531 L 16.472656 37 L 12.980469 37 L 10 23 L 13.355469 23 L 14.960938 31.777344 L 16.882813 23 L 19.75 23 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1565C0"
    },
    d: "M 33.9375 37 C 32.457031 37 31.257813 36.558594 30.34375 35.675781 C 29.429688 34.792969 28.972656 33.648438 28.972656 32.234375 L 28.972656 31.984375 C 28.972656 30.996094 29.15625 30.128906 29.519531 29.371094 C 29.886719 28.617188 30.421875 28.03125 31.121094 27.621094 C 31.820313 27.207031 32.652344 27 33.613281 27 C 34.96875 27 36.039063 27.421875 36.824219 28.261719 C 37.609375 29.101563 38 30.273438 38 31.777344 L 38 32.945313 L 32.027344 32.945313 C 32.136719 33.484375 32.371094 33.910156 32.734375 34.21875 C 33.09375 34.527344 33.566406 34.683594 34.140625 34.683594 C 35.089844 34.683594 35.832031 34.351563 36.367188 33.683594 L 37.742188 35.304688 C 37.367188 35.824219 36.835938 36.234375 36.152344 36.539063 C 35.464844 36.847656 34.726563 37 33.9375 37 Z M 33.597656 29.316406 C 32.71875 29.316406 32.195313 29.898438 32.03125 31.0625 L 35.058594 31.0625 L 35.058594 30.832031 C 35.070313 30.351563 34.949219 29.976563 34.695313 29.714844 C 34.441406 29.449219 34.074219 29.316406 33.597656 29.316406 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.50bc94367035400bcb84f467b9c8ae86.svg";
export { ForwardRef as ReactComponent };